export const fetchWithAuth = async (url, options = {}) => {
  // url = "http://localhost:8000" + url;
  url = "https://api.islorg.com" + url;
  const user = JSON.parse(localStorage.getItem("user"));

  const headers = {
    ...options.headers,
    Authorization: `Bearer ${user?.token}`,
  };

  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  const response = await fetch(url, { ...options, headers });
  if (response.status === 401 || response.status === 403) {
    localStorage.removeItem("user");
    window.location.href = "/login";
    return;
  }
  return response;
};